module.exports = __webpack_public_path__ + "img/9788957981849.f6a4fc6f.jpg";